import { render, staticRenderFns } from "./BerlianTerjualCabangView.vue?vue&type=template&id=511dc904&"
import script from "./BerlianTerjualCabangView.vue?vue&type=script&lang=js&"
export * from "./BerlianTerjualCabangView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports